export default "__VITE_ASSET__Dkyi_GBJ__"